import { clsx } from "clsx";
import { twMerge } from "./tailwind-merge.js";
function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export { cn };
